import { cn } from "@omni/utils/styles";

import { SEARCH_CONTENT_ID } from "@/components/Search/SearchResults/StateComponents/NumberOfHits/numberOfHits.container";
import { ContentPagination } from "@/components/Search/SearchResults/StateComponents/Pagination/paginationComponents";
import { ContentResultList } from "@/components/Search/SearchResults/StateComponents/ResultList/resultListComponents";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type ContentSearchResultsComponentProps = {
    expanded: boolean;
};

const ContentSearchResultsComponent = ({
    expanded
}: ContentSearchResultsComponentProps) => {
    const { t } = useGranite();

    return (
        <article
            id={SEARCH_CONTENT_ID}
            className={cn("tw:col-[1/3]", {
                "tw:row-[1/3]": expanded,
                "tw:lg:col-[2/3]": !expanded
            })}
        >
            <h3>{t("search.results.title.contentPages")}</h3>
            <ContentResultList className={cn("tw:mb-3")} />
            <ContentPagination className={cn("tw:mb-3")} />
        </article>
    );
};

export { ContentSearchResultsComponent };
